module.exports = __webpack_public_path__ + "static/media/08-quiz.1fe48659.png";